import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { colors } from "src/config/colors";
import Container from "src/components/common/Layout/Container";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import { ToBookButton } from "src/components/common/Buttons/ToBookButton";
import SubmitButton from "src/components/common/Buttons/SubmitButton";
import { Theme } from "@mui/system";

interface ProductItemProps {
  productName?: string;
  pharmacyName?: string;
  pharmacyAddress?: string;
  price?: number;
  allowCart?: boolean;
  futureBooking?: boolean;
  isListPriorOffer?: boolean;
  isMapPriorOffer?: boolean;
  exclusivePrice: number;
  imgSrc?: string;
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  disableBorder?: boolean;
  toBookClick: () => void;
}

const ProductItem: React.FC<ProductItemProps> = ({
  productName,
  imgSrc,
  setOpenDetailModal,
  disableBorder,
  pharmacyName,
  pharmacyAddress,
  price,
  allowCart,
  futureBooking,
  isListPriorOffer,
  isMapPriorOffer,
  exclusivePrice,
  toBookClick,
}) => {
  const isMediumScreenDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md")
  );

  return (
    <Container
      component="li"
      sx={{
        backgroundColor:
          isMapPriorOffer || isListPriorOffer ? "#FEF9F4" : colors.white,
        borderRadius: disableBorder ? "0px" : { xs: "0px", md: "8px" },
        boxShadow: disableBorder ? "0px" : "0px 1px 8px rgba(0, 0, 0, 0.1)",
        paddingTop: "15px",
        paddingBottom: { xs: "20px", md: "15px" },
        width: "100%",
        display: "flex",
        position: "relative",
        paddingX: { xs: 2, sm: 2.5, lg: 3.75 },
      }}
    >
      <Box
        sx={{
          display: isMapPriorOffer || isListPriorOffer ? "flex" : "none",
          width: { xs: "10px", md: "12px" },
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          borderTopLeftRadius: { xs: "0xp", md: "8px" },
          borderBottomLeftRadius: { xs: "0xp", md: "8px" },
          backgroundColor: "#D9821C",
        }}
      />
      {/*<Box sx={{ mr: "12px", display: { xs: "none", md: "block" } }}>
        <Image
          src={imgSrc || "https://via.placeholder.com/60"}
          alt={productName}
          width={80}
          height={80}
        />
      </Box>*/}
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 1,
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              component="h4"
              sx={{
                fontSize: { xs: "18px", md: "20px" },
                color: colors.blue,
                lineHeight: "20px",
                mb: "6px",
              }}
            >
              {productName}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            mb: { xs: !allowCart || exclusivePrice > 0 ? 1.5 : 0, md: 0 },
          }}
        >
          <Box sx={{ width: "100%", mr: { xs: 1, md: 5 } }}>
            <Typography
              component="h6"
              sx={{
                fontSize: { xs: "13px", md: "14px" },
                color: colors.blue,
                lineHeight: "14px",
                mb: "3px",
              }}
            >
              {pharmacyName}
            </Typography>
            <Typography
              component="h6"
              sx={{
                fontSize: "13px",
                color: colors.gray3,
                lineHeight: "14px",
              }}
            >
              {pharmacyAddress}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: "5px",
                flexDirection: "row",
              }}
            >
              <Typography
                component="h6"
                sx={{
                  display: { xs: "none", md: "block" },
                  fontSize: "24px",
                  fontWeight: 700,
                  color: colors.blue,
                  mr: 5,
                  whiteSpace: "nowrap",
                }}
              >
                {price} ₽
              </Typography>
              {!allowCart ? (
                <SubmitButton
                  typographySx={{
                    fontSize: { xs: "10px", md: "12px" },
                    lineHeight: { xs: "12px", md: "15px" },
                  }}
                  sx={{
                    display: allowCart ? "none" : "flex", // Кнопка "бронирование недоступно"
                    width: { xs: "120px", md: "155px" },
                    height: "45px",
                  }}
                  disabled
                  title={
                    isMediumScreenDown
                      ? "Бронирование недоступно"
                      : `Бронирование недоступно за ${price} ₽`
                  } // Вставить цену внутрь на мобилке, если бронь недоступна
                />
              ) : (
                <ToBookButton
                  onOrder={allowCart && futureBooking}
                  price={price}
                  onClick={toBookClick}
                />
              )}
            </Box>
            <Box
              sx={{
                display: "inline-flex", // inline-flex по флагу
                alignItems: "center",
                width: "100%",
                position: { xs: "absolute", md: "static" },
                left: 0,
                top: 50,
                justifyContent: "start",
              }}
            >
              <Box
                sx={{
                  display: allowCart ? "none" : "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <CancelIcon color="error" sx={{ mr: "4px" }} />
                <Typography
                  component="span"
                  sx={{
                    fontSize: { xs: "11px", md: "12px" },
                    color: colors.blue,
                    lineHeight: "14px",
                  }}
                >
                  Бронирование через ЦЕНЫвАПТЕКАХ недоступно
                </Typography>
              </Box>
              {exclusivePrice > 0 && (
                <>
                  <Box
                    sx={{
                      minWidth: "20px",
                      minHeight: "20px",
                      backgroundColor: "#d32f2f",
                      borderRadius: "50%",
                      color: colors.white,
                      position: "relative",
                      mr: "4px",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-1.5px",
                        left: "5px",
                        fontSize: "14px",
                      }}
                    >
                      %
                    </Box>
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontSize: "12px",
                      lineHeight: "14px",
                      color: colors.blue,
                      display: "inline-block",
                    }}
                  >
                    Этот товар можно купить за
                    <Box
                      component="span"
                      sx={{
                        ml: "3px",
                        fontWeight: 700,
                        color: colors.red,
                        whiteSpace: "nowrap",
                      }}
                    >
                      312 ₽.
                    </Box>
                    <Box
                      onClick={() => setOpenDetailModal(true)}
                      component="span"
                      sx={{
                        ml: "3px",
                        textDecoration: "underline",
                        fontWeight: 400,
                        color: colors.blue2,
                      }}
                    >
                      Подробнее
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ProductItem;
